const React = require('react')
const { ChipsProvider } = require('./src/context/activeChipsNavigation')

require('./src/css/index.css')

exports.onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    require(`intersection-observer`)
    console.log(`# IntersectionObserver is polyfilled!`)
  }
}

exports.wrapRootElement = ({ element }) => {
  return (
    <ChipsProvider>
      <div id="top">{element}</div>
    </ChipsProvider>
  )
}

exports.onInitialClientRender = () => {
  // todo here checking if shoppingListItems are available or not and update items
}

exports.shouldUpdateScroll = ({ routerProps, getSavedScrollPosition }) => {
  window.history.scrollRestoration = 'manual'
  const currentPosition = getSavedScrollPosition(routerProps?.location) || [
    0, 0
  ]

  setTimeout(() => {
    if (location.hash) {
      // If hash (`/#something`), smooth scroll to that position
      const item = document.querySelector(`${location.hash}`)
      item?.scrollIntoView({ behavior: 'smooth' })
    } else {
      // when using the browser back/forward buttons or navigating to a different page client-side, instant scroll to its last saved position
      window.scrollTo({
        top: currentPosition[1],
        left: currentPosition[0],
        behavior: 'instant'
      })
    }
  }, 0)

  return false
}

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (!location.hash) {
    // do not restore scroll position on page refresh without hash
    setTimeout(
      () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }),
      0
    )
  }

  if (location && location.state)
    location.state.referrer = prevLocation ? prevLocation.pathname : null
}

//for future usage to inform users about site-updates

// exports.onServiceWorkerUpdateReady = () => {
//   // eslint-disable-next-line no-alert
//   const answer = window.confirm(
//     `Diese Anwendung wurde aktualisiert. ` +
//       `Möchten Sie neu laden, um die neueste Version anzuzeigen?`
//   )

//   if (answer) {
//     window.location.reload()
//   }
// }
